var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "gfu-grid__cell gfu-1of3 _mt-1",
          attrs: { "data-qa": `filtersbox-field:${_vm.displayName}` },
        },
        [
          _c("field-label", {
            staticClass: "gfu-field__label--gray _mt-1",
            attrs: { text: _vm.displayName },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "gfu-grid gfu-grid--gutter-columns" }, [
            _c(
              "div",
              { staticClass: "gfu-grid__cell gfu-6of12" },
              [
                _c("date-field", {
                  staticClass: "_ma-0",
                  attrs: {
                    "display-name": "Min date",
                    name: "model.minDate",
                    "show-label": false,
                    small: true,
                    "value-type": "auto",
                    "data-qa": "date-field:MinDate",
                  },
                  on: { input: _vm.onChange },
                  model: {
                    value: _vm.minDateModel,
                    callback: function ($$v) {
                      _vm.minDateModel = $$v
                    },
                    expression: "minDateModel",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-divider gfu-divider--small" }, [
              _vm._v("to"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gfu-grid__cell gfu-6of12" },
              [
                _c("date-field", {
                  staticClass: "_ma-0",
                  attrs: {
                    "display-name": "Max date",
                    name: "model.minDate",
                    "show-label": false,
                    small: true,
                    "value-type": "auto",
                    "data-qa": "date-field:MaxDate",
                  },
                  on: { input: _vm.onChange },
                  model: {
                    value: _vm.maxDateModel,
                    callback: function ($$v) {
                      _vm.maxDateModel = $$v
                    },
                    expression: "maxDateModel",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }